<script lang="ts">
  import { Button, Col, Row } from "sveltestrap";
  import { href, jobfilter } from "../../../../utils/Constant/Constant";
  import Filter from "./Filter.svelte";
  import Location from "./Location.svelte";
  import JobTitle from "./JobTitle.svelte";
  import Industry from "./Industry.svelte";
  import SpecificSkills from "./SpecificSkills.svelte";
  let classFilter:boolean = false
  function handleFilter (){
    classFilter = !classFilter
  }

</script>
<Col xl="3" class="xl-40 box-col-4">
    <div class="job-sidebar">
        <Button color="primary" class="job-toggle" href={href} on:click={handleFilter}>{jobfilter}</Button>
        <div class="job-left-aside custom-scrollbar {classFilter ? "open" : ""}">
            <div class="default-according style-1 faq-accordion job-accordion" id="accordionoc">
                <Row>
                    <Filter />
                    <Location />
                    <JobTitle />
                    <Industry />
                    <SpecificSkills />
                </Row>
            </div>
        </div>
    </div>
</Col>